import { createStore } from "owa-satcheljs";

interface CopilotCommandCenterStore {
    isCommandCenterVisible: boolean;
    shouldRenderCommandCenterPlaceholder: boolean;
}

const defaultExport: () => CopilotCommandCenterStore = createStore<CopilotCommandCenterStore>("CopilotCommandCenterStore", {
    isCommandCenterVisible: false,
    shouldRenderCommandCenterPlaceholder: false,
});
export default defaultExport;
